import { render, staticRenderFns } from "./base-card.vue?vue&type=template&id=9ad2bbb6&scoped=true&lang=pug&"
import script from "./base-card.vue?vue&type=script&lang=js&"
export * from "./base-card.vue?vue&type=script&lang=js&"
import style0 from "./base-card.vue?vue&type=style&index=0&id=9ad2bbb6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad2bbb6",
  null
  
)

export default component.exports